import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBetween = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 10.3333C2 11.0083 2.54721 11.5556 3.22222 11.5556C3.89724 11.5556 4.44444 11.0083 4.44444 10.3333V4.22222C4.44444 3.54721 3.89724 3 3.22222 3C2.54721 3 2 3.54721 2 4.22222V10.3333ZM11.7778 11.5556C11.1028 11.5556 10.5555 11.0083 10.5555 10.3333V4.22222C10.5555 3.54721 11.1028 3 11.7778 3C12.4528 3 13 3.54721 13 4.22222V10.3333C13 11.0083 12.4528 11.5556 11.7778 11.5556ZM7.50001 9.11111C6.48749 9.11111 5.66668 8.2903 5.66668 7.27778C5.66668 6.26526 6.48749 5.44445 7.50001 5.44445C8.51253 5.44445 9.33334 6.26526 9.33334 7.27778C9.33334 8.2903 8.51253 9.11111 7.50001 9.11111Z",
		fill: "currentColor"
	})
});
export default SvgIconBetween;
